import { createSlice } from "@reduxjs/toolkit";
import { deleteWarning } from "./warningsThunks";
import { LoadingStatus } from "common/types";

export interface DeleteWarningState {
  status: LoadingStatus;
}

const initialState: DeleteWarningState = {
  status: "idle",
};

export const deleteWarningSlice = createSlice({
  name: "warnings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteWarning.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteWarning.fulfilled, (state, action) => {
        state.status = "idle";
      })
      .addCase(deleteWarning.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

export default deleteWarningSlice.reducer;
